import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRemoveFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 8C17.6266 8 15.3066 8.70379 13.3332 10.0224C11.3598 11.3409 9.8217 13.2151 8.91345 15.4078C8.0052 17.6005 7.76756 20.0133 8.23058 22.3411C8.6936 24.6689 9.83649 26.8071 11.5147 28.4853C13.193 30.1635 15.3312 31.3064 17.6589 31.7694C19.9867 32.2324 22.3995 31.9948 24.5922 31.0866C26.7849 30.1783 28.6591 28.6402 29.9776 26.6668C31.2962 24.6935 32 22.3734 32 20C31.9908 16.8202 30.7235 13.7734 28.4751 11.5249C26.2266 9.27648 23.1798 8.00923 20 8V8ZM24.95 23.536L23.536 24.95L20 21.414L16.464 24.95L15.05 23.536L18.586 20L15.05 16.464L16.464 15.05L20 18.586L23.536 15.05L24.95 16.464L21.414 20L24.95 23.536Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgRemoveFilled);
export default ForwardRef;
